'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _allAffected = require('./utils/all-affected');

var _allAffected2 = _interopRequireDefault(_allAffected);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var focusInFrame = function focusInFrame(frame) {
  return frame === document.activeElement;
};

var focusInsideIframe = function focusInsideIframe(topNode) {
  return (0, _allAffected2.default)(topNode).reduce(function (result, node) {
    return result || !![].concat(_toConsumableArray(node.querySelectorAll('iframe'))).find(focusInFrame);
  }, false);
};

var focusInside = function focusInside(topNode) {
  return (0, _allAffected2.default)(topNode).reduce(function (result, node) {
    return result || node.querySelector('*:focus') || focusInsideIframe(topNode);
  }, false);
};

exports.default = focusInside;